// Gates a user action behind authentication. Mirrors `useProGate` for the
// logged-in requirement: call `requireLogin` before an action, and
// unauthenticated visitors are sent to `/getstarted` (via `buildLoginRedirect`)
// with a return path so they land back here after signing in.
export default function () {
  const authStore = useAuthStore()
  const route = useRoute()
  const router = useRouter()

  const isLoggedIn = computed(() => !!authStore.session_data.user)

  const redirectToLogin = (returnPath?: string) => {
    return router.push(
      buildLoginRedirect({ fullPath: returnPath ?? route.fullPath, query: route.query })
    )
  }

  const requireLogin = (
    loggedInCallback?: (...args: any) => any,
    options?: { returnPath?: string }
  ): boolean => {
    if (!isLoggedIn.value) {
      redirectToLogin(options?.returnPath)
      return false
    }

    loggedInCallback?.()

    return true
  }

  return {
    isLoggedIn,
    requireLogin,
    redirectToLogin
  }
}
